import { CountryConfig, Configurable } from '@crystal/config'

import { MfSiteConfig } from '../types'

const mfSiteConfig = Configurable.props<Partial<MfSiteConfig>>({
  socialProviders: [
    {
      id: 'kakao',
      displayName: 'Kakao',
    },
    {
      id: 'naver',
      displayName: 'Naver',
    },
  ],
  isKmcFlowRequired: true,
})

export const KR: CountryConfig<Partial<MfSiteConfig>> = {
  KR: mfSiteConfig,
}
